export const prepParams = (url: string, globalFilters: any, gridFilters: any = undefined,  gridFiltersConfig: any = undefined) => {
    const params: any = {}
    const paramKeysToRemove: any = []
    const [baseUrl, queryString] = url.split('?')

    // parse the existing query string of the url into an params object,
    // keeping track of the raw key so we can drop the placeholder key later on
    const urlParams: Record<string, string> = {}
    if (queryString) {
        for (const pair of queryString.split('&')) {
            if (!pair) { continue }
            const [key, value = ''] = pair.split('=')
            urlParams[key] = value
        }
    }    
    
    if (!('action' in urlParams) && !url.includes('action=')) {
        params['action'] = 'gte'
    }

    // find the url param that references globalFilters.fromFilter (placeholder value) so it can be excluded from url_converted,
    // regardless of whether globalFilters.fromFilter is actually set
    const fromFilterKey = Object.keys(urlParams).find((key) => urlParams[key] === 'globalFilters.fromFilter')
    paramKeysToRemove.push(fromFilterKey)

    if (fromFilterKey && globalFilters && globalFilters.fromFilter) {
        params[`MIN_${fromFilterKey}`] = globalFilters.fromFilter.from
        params[`MAX_${fromFilterKey}`] = globalFilters.fromFilter.to
    }

    const objectFilterKey = Object.keys(urlParams).find((key) => urlParams[key] === 'globalFilters.objectFilter')
    paramKeysToRemove.push(objectFilterKey)

    if (objectFilterKey && globalFilters) {
        params[objectFilterKey] = globalFilters.objectFilter || 'alle'
    }

    if (gridFilters) {
        for(const f in gridFiltersConfig) {
            const { prop, param, url_param } = gridFiltersConfig[f]
            if (url_param){
                continue  // already in url as direct param
            }

            if (prop && gridFilters.lookupValues[f]) {  // we need a property from the lookup object
                params[`MIN_${ param }`] = gridFilters.lookupValues[f][prop]
                params[`MAX_${ param }`] = gridFilters.lookupValues[f][prop]
            } else if (!prop && gridFilters.values[f]) {
                params[`MIN_${ param }`] = gridFilters.values[f]
                params[`MAX_${ param }`] = gridFilters.values[f]
            }
        }
    }

    // rebuild the url from its own query params, excluding the fromFilter placeholder param
    const remainingUrlParams = Object.entries(urlParams).filter(([key]) => !paramKeysToRemove.includes(key))
    const url_converted = remainingUrlParams.length
        ? `${baseUrl}?${remainingUrlParams.map(([key, value]) => `${key}=${value}`).join('&')}`
        : baseUrl

    return [url_converted, params]
}
